import {
  Grid,
  Icon,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import Trend from "pages/Performance/components/Trend";
import React, { useState } from "react";
import { numberFormatter } from "utils/HelperFunctions";
import sampleProfileImage from "assets/images/sample.png";
import FlameIcon from "components/Icons/FlameIcon";
import TooltipLight from "utils/TooltipLight";

function TableListingForManager({
  data,
  onUserClick,
  selectedUserId,
  setSelectedTeam,
  streakData,
}) {
  const theme = useTheme();
  const MINIMUM_STREAK_DAYS = 3;
  const [searchByName, setSearchByName] = useState("");
  const concatArray = data.users || [];

  let allUsers = [];

  data.users.forEach((singleUser) => {
    allUsers = allUsers.concat(singleUser.totalPerformance);
  });

  const handleSearchFilter = (user) => {
    if (!searchByName) {
      return true;
    }
    return user?.name?.toLowerCase().includes(searchByName.toLowerCase());
  };

  const renderAvatar = (row) => {
    const userStreakData = streakData?.find(
      (user) => user.userCompanyLinkId === row.userCompanyLinkId
    );
    const activeStreak = userStreakData?.activeStreak || 0;
    const avatar = <MDAvatar variant="circular" src={row.profilePicture || sampleProfileImage} />;
    let streakDisplay = "";
    if (activeStreak >= MINIMUM_STREAK_DAYS) {
      streakDisplay = (
        <Box sx={{ position: "absolute", top: "14px", left: "24px" }}>
          <FlameIcon sx={{ width: "26px", height: "26px" }} count={activeStreak} variant="basic" />
        </Box>
      );
    }
    return (
      <Box sx={{ position: "relative" }}>
        {avatar}
        {streakDisplay}
      </Box>
    );
  };

  return (
    <MDBox mt={2}>
      <Grid
        container
        spacing={2}
        sx={{
          "& .MuiPaper-root": {},
        }}
      >
        <Grid item xs={12} sx={{ position: "relative" }}>
          <TableContainer
            component={Paper}
            sx={{
              userSelect: "none",
              height: "100%",
            }}
          >
            <MDBox
              sx={{
                pt: "16px",
                pl: "32px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <MDTypography variant="h6" sx={{ color: "info" }} mb={0}>
                {data.name}
              </MDTypography>
              <MDBox display="flex" justifyContent="center" alignItems="center">
                <MDInput
                  sx={{
                    "& .MuiInputLabel-root": {
                      lineHeight: "normal",
                      top: "-6px",
                    },
                    "& input": {
                      p: "0.5rem",
                    },
                  }}
                  value={searchByName}
                  onChange={(event) => setSearchByName(event.target.value)}
                  label="Search member"
                />
                <IconButton
                  size="large"
                  color="inherit"
                  variant="contained"
                  onClick={() => {
                    setSelectedTeam(null);
                    onUserClick(0);
                  }}
                >
                  <Icon fontSize="medium">arrow_back</Icon>
                  <MDTypography variant="body2" ml={1}>
                    Back to teams
                  </MDTypography>
                </IconButton>
              </MDBox>
            </MDBox>
            <Table aria-label="simple table">
              <TableHead sx={{ display: "table-header-group" }}>
                <TableRow>
                  <TableCell align="left">
                    <MDTypography
                      sx={{
                        fontSize: "0.9rem",
                        fontWeight: "400",
                        color: "#888",
                      }}
                    >
                      Team Member
                    </MDTypography>
                  </TableCell>
                  <TableCell align="center">
                    <MDTypography
                      sx={{
                        fontSize: "0.9rem",
                        fontWeight: "400",
                        color: "#888",
                      }}
                    >
                      Completed KPIs
                    </MDTypography>
                  </TableCell>
                  {/* <TableCell align="center">
                    <MDTypography
                      sx={{
                        fontSize: "0.9rem",
                        fontWeight: "400",
                        color: "#888",
                      }}
                    >
                      Average KPIs
                    </MDTypography>
                  </TableCell> */}
                  <TableCell align="center">
                    <MDTypography
                      sx={{
                        fontSize: "0.9rem",
                        fontWeight: "400",
                        color: "#888",
                      }}
                    >
                      Achieved Points
                    </MDTypography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow
                  className={!selectedUserId ? "selected" : null}
                  sx={{
                    background: !selectedUserId && theme.palette.gray[80],
                    cursor: "pointer",
                  }}
                  style={{ cursor: "pointer" }}
                  onClick={() => onUserClick(0)}
                >
                  <TableCell>All members</TableCell>
                  <TableCell align="center">
                    <MDBox
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {numberFormatter(
                        allUsers.reduce((previousValue, currentValue) => {
                          previousValue += currentValue ? currentValue.totalKpiCompleted : 0;

                          return previousValue;
                        }, 0)
                      )}

                      <MDTypography
                        variant="subtitle1"
                        sx={{
                          pb: "0.3rem",
                        }}
                      >
                        <Trend
                          prev={allUsers.reduce((previousValue, currentValue) => {
                            if (
                              currentValue.totalKpiCompletedTrend ===
                                currentValue.totalKpiCompleted ||
                              currentValue.totalKpiCompletedTrend === 0 ||
                              currentValue.totalKpiCompletedTrend === "0.0" ||
                              currentValue.totalKpiCompleted === 0 ||
                              currentValue.totalKpiCompleted === "0.0"
                            )
                              return previousValue;

                            previousValue += currentValue ? currentValue.totalKpiCompletedTrend : 0;
                            return previousValue;
                          }, 0)}
                          curr={allUsers.reduce((previousValue, currentValue) => {
                            if (
                              currentValue.totalKpiCompletedTrend ===
                                currentValue.totalKpiCompleted ||
                              currentValue.totalKpiCompletedTrend === 0 ||
                              currentValue.totalKpiCompletedTrend === "0.0" ||
                              currentValue.totalKpiCompleted === 0 ||
                              currentValue.totalKpiCompleted === "0.0"
                            )
                              return previousValue;

                            previousValue += currentValue ? currentValue.totalKpiCompleted : 0;
                            return previousValue;
                          }, 0)}
                          type="percent"
                          fieldLabel="completed kpis"
                          overrideTitle={{
                            start: "The completed KPIs have",
                            end: "from the previous day.",
                          }}
                        />
                      </MDTypography>
                    </MDBox>
                  </TableCell>
                  {/* <TableCell align="center">
                    {Math.round(
                      numberFormatter(
                        allUsers.reduce((previousValue, currentValue) => {
                          previousValue += currentValue ? currentValue.avgKpiCompleted : 0;

                          return previousValue;
                        }, 0) / (allUsers.length || 1)
                      )
                    )}
                  </TableCell> */}
                  <TableCell align="center">
                    {numberFormatter(
                      allUsers.reduce((previousValue, currentValue) => {
                        previousValue += currentValue ? currentValue.points : 0;

                        return previousValue;
                      }, 0)
                    )}
                  </TableCell>
                </TableRow>
                {concatArray
                  ?.filter(handleSearchFilter)
                  .sort((a, b) => {
                    // If neither has permission, maintain their relative order
                    if (!a.inputKPIPermission && !b.inputKPIPermission) return 0;

                    // If a doesn't have permission, move it to the end
                    if (!a.inputKPIPermission) return 1;

                    // If b doesn't have permission, move it to the end
                    if (!b.inputKPIPermission) return -1;

                    return (
                      numberFormatter(b.totalPerformance?.[0]?.points || 0) -
                      numberFormatter(a.totalPerformance?.[0]?.points || 0)
                    );
                  })
                  .map((row) => (
                    <TableRow
                      className={selectedUserId === row?.userId ? "selected" : null}
                      sx={{
                        background: selectedUserId === row?.userId && theme.palette.gray[80],
                        cursor: "pointer",
                      }}
                      key={row.userId}
                      style={{ cursor: "pointer" }}
                      onClick={() => onUserClick(row.userId)}
                    >
                      <TableCell
                        sx={{ color: row?.isDisabled ? theme.palette.text.disabled : "inherit" }}
                      >
                        <Stack direction="row" spacing={4} alignItems="center">
                          {renderAvatar(row)}
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <MDBox mr={1} sx={{ color: "inherit" }}>
                              {row.name}
                            </MDBox>
                            {!row.inputKPIPermission ? (
                              <TooltipLight title="Does not input KPIs">
                                <span
                                  className="material-symbols-outlined"
                                  style={{ fontSize: "1.2rem", color: "#aaa", ml: 0 }}
                                >
                                  unpublished
                                </span>
                              </TooltipLight>
                            ) : null}
                          </Box>
                          {row.totalPerformance?.[0]?.outOfOffice ? (
                            <span
                              className="material-symbols-outlined"
                              style={{ fontSize: "1.4rem" }}
                            >
                              event_busy
                            </span>
                          ) : null}
                        </Stack>
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: row?.isDisabled ? theme.palette.text.disabled : "inherit" }}
                      >
                        <MDBox
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {row.inputKPIPermission
                            ? numberFormatter(row.totalPerformance?.[0]?.totalKpiCompleted || 0)
                            : "-"}
                          <MDTypography
                            variant="subtitle1"
                            sx={{
                              pb: "0.3rem",
                            }}
                          >
                            <Trend
                              prev={row.totalPerformance?.[0]?.totalKpiCompletedTrend || 0}
                              curr={row.totalPerformance?.[0]?.totalKpiCompleted || 0}
                              type="percent"
                              fieldLabel="completed kpis"
                              overrideTitle={{
                                start: "The completed KPIs have",
                                end: "from the previous day.",
                              }}
                            />
                          </MDTypography>
                        </MDBox>
                      </TableCell>
                      {/* <TableCell
                      align="center"
                      sx={{ color: row?.isDisabled ? theme.palette.text.disabled : "inherit" }}
                    >
                      {Math.round(
                        numberFormatter(row.totalPerformance?.[0]?.avgKpiCompleted || 0) * 10
                      ) / 10}
                    </TableCell> */}
                      <TableCell
                        align="center"
                        sx={{ color: row?.isDisabled ? theme.palette.text.disabled : "inherit" }}
                      >
                        {row.inputKPIPermission
                          ? numberFormatter(row.totalPerformance?.[0]?.points || 0)
                          : "-"}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default TableListingForManager;
